function datepickerShortcuts(instance, configName, additionalConfig) {
  const createShortcut = (text, index, value) => ({
    text,
    value,
    onClick: () => {
      const [dateStart, dateEnd] = value()
      localStorage.setItem(
        configName,
        JSON.stringify({
          startDate: dateStart.toISOString(),
          endDate: dateEnd.toISOString(),
          isShortcut: true,
          index,
          ...additionalConfig,
        })
      )
      return [dateStart, dateEnd]
    },
  })

  return [
    createShortcut(instance.$t('global.time.today'), 0, () => {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    }),
    createShortcut(instance.$t('global.time.yesterday'), 1, () => {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
      dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    }),
    createShortcut(instance.$t('global.time.last7Days'), 2, () => {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 144)
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    }),
    createShortcut(instance.$t('global.time.last30Days'), 3, () => {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 696)
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    }),
    createShortcut(instance.$t('global.time.thisMonth'), 4, () => {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * (dateEnd.getDate() - 1))
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    }),
    createShortcut(instance.$t('global.time.lastMonth'), 5, () => {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * dateStart.getDate())
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * (dateStart.getDate() - 1))
      dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24 * dateEnd.getDate())
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    }),
  ]
}

export default datepickerShortcuts
